<adaa-auth-layout>
    @if (!isUserDefined()) {
        <div class="adaa-auth-status">
            <div class="adaa-auth-status-icon adaa-auth-status-icon--error">
                <i class="fa-solid fa-xmark"></i>
            </div>
            @if (errorMessage(); as message) {
                <div class="adaa-auth-subtitle">{{ message | translate }}</div>
            } @else {
                <div class="adaa-auth-subtitle">{{ "login.user_not_found" | translate }}</div>
                <p class="adaa-auth-text">{{ "login.user_not_found_instructions" | translate }}</p>
            }
            <button type="button" class="adaa-auth-btn adaa-auth-btn-ghost" [routerLink]="'/login'">{{ "login.go_back" | translate }}</button>
        </div>
    } @else if (newPasswordForm(); as passwordForm) {
        <form [formGroup]="passwordForm">
            @if (currentStep() === 1) {
                <div class="adaa-auth-subtitle">{{ AdaaHelper.getItemValueByToken(user(), "name") }}</div>
                <p class="adaa-auth-text" style="margin-bottom: 8px">{{ user()?.email }}</p>
                <p class="adaa-auth-text">{{ "login.text_select_identity" | translate }}</p>

                <div class="adaa-auth-methods">
                    @for (option of resetPasswordOptions(); track option.value) {
                        <button
                            type="button"
                            class="adaa-auth-method"
                            [class.active]="verificationMethodValue === option.value"
                            (click)="resetPasswordOptionsUpdated(option.value)"
                        >
                            <i class="fa-solid {{ option.icon }}"></i>
                            <span>{{ option.text }}</span>
                        </button>
                    }
                </div>

                @if (verificationMethodValue === verificationMethod.SMS) {
                    @if (lockCounter() === 0) {
                        <button type="button" class="adaa-auth-btn adaa-auth-btn-ghost mt-2 mb-4" (click)="sendVerificationCode()">
                            {{ "common.form.button.send" | translate }}
                        </button>
                    } @else {
                        <button type="button" class="adaa-auth-btn adaa-auth-btn-ghost mt-2 mb-4 disabled-button">
                            {{ "login.resendCode" | translate }} - {{ lockCounter() }}
                        </button>
                    }

                    <div class="adaa-auth-field">
                        <adaa-form-input
                            [required]="true"
                            [placeholder]="'login.confirmation_code' | translate"
                            controlName="verificationCode"
                            formControlName="verificationCode"
                            inputType="positiveNumber"
                            [maxLength]="999999"
                            [invalid]="passwordForm.get('verificationCode')?.errors?.['required']"
                        ></adaa-form-input>
                    </div>
                } @else if (verificationMethodValue === verificationMethod.QUESTIONS) {
                    <div class="adaa-auth-field mt-2">
                        <adaa-form-input
                            [placeholder]="'login.answer' | translate"
                            [label]="AdaaHelper.getItemValueByToken(questions()[0], 'dsc')"
                            controlName="firstQuestion"
                            formControlName="firstQuestion"
                            inputType="text"
                            [invalid]="passwordForm.get('firstQuestion')?.errors?.['required']"
                        ></adaa-form-input>
                    </div>
                    <div class="adaa-auth-field">
                        <adaa-form-input
                            [placeholder]="'login.answer' | translate"
                            [label]="AdaaHelper.getItemValueByToken(questions()[1], 'dsc')"
                            controlName="secondQuestion"
                            formControlName="secondQuestion"
                            inputType="text"
                            [invalid]="passwordForm.get('secondQuestion')?.errors?.['required']"
                        ></adaa-form-input>
                    </div>
                }

                <button type="button" (click)="validateAccount()" class="adaa-auth-btn adaa-auth-btn-primary">
                    {{ "login.confirm" | translate }}
                </button>
            } @else if (currentStep() === 2) {
                <div class="adaa-auth-subtitle">{{ "login.create_password" | translate }}</div>

                <div class="adaa-auth-rules">
                    <div class="adaa-auth-rule">{{ "new_password.error.check_english_letters" | translate }}</div>
                    <div class="adaa-auth-rule">{{ "new_password.error.check_numbers" | translate }}</div>
                    <div class="adaa-auth-rule">{{ "new_password.error.check_password_length" | translate }}</div>
                </div>

                <div class="adaa-auth-field adaa-auth-field--password">
                    <adaa-form-input
                        [required]="true"
                        [placeholder]="'login.password' | translate"
                        controlName="password"
                        formControlName="password"
                        [inputType]="showPassword() ? 'text' : 'password'"
                        [invalid]="passwordForm.get('password')?.errors?.['required']"
                    ></adaa-form-input>
                    <button type="button" class="adaa-auth-eye" (click)="showPassword.set(!showPassword())">
                        <i class="fa-solid" [class.fa-eye-slash]="showPassword()" [class.fa-eye]="!showPassword()"></i>
                    </button>
                </div>

                <div class="adaa-auth-field adaa-auth-field--password">
                    <adaa-form-input
                        [required]="true"
                        [placeholder]="'login.password_confirm' | translate"
                        controlName="confirmPassword"
                        formControlName="confirmPassword"
                        [inputType]="showConfirmPassword() ? 'text' : 'password'"
                        [invalid]="passwordForm.get('confirmPassword')?.errors?.['required']"
                    ></adaa-form-input>
                    <button type="button" class="adaa-auth-eye" (click)="showConfirmPassword.set(!showConfirmPassword())">
                        <i class="fa-solid" [class.fa-eye-slash]="showConfirmPassword()" [class.fa-eye]="!showConfirmPassword()"></i>
                    </button>
                </div>

                <button type="button" (click)="validatePassword()" class="adaa-auth-btn adaa-auth-btn-primary">
                    {{ "login.confirm" | translate }}
                </button>
            }
        </form>
    }
</adaa-auth-layout>
